import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSocial } from '../contexts/SocialContext';

/**
 * Keeps Open Graph & Twitter Card meta tags in sync with admin-configured values
 * and pushes the current canonical URL on every route change so that social
 * crawlers (and the in-app share button) always pick up the right preview.
 */
const upsertMeta = (selector, attrs) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement('meta');
    Object.entries(attrs).forEach(([k, v]) => {
      if (k !== 'content') el.setAttribute(k, v);
    });
    document.head.appendChild(el);
  }
  el.setAttribute('content', attrs.content || '');
};

export const SocialMeta = () => {
  const { social } = useSocial();
  const location = useLocation();

  useEffect(() => {
    const title = social.ogTitle || document.title;
    const desc = social.ogDescription || '';
    const img = social.ogImageUrl || '';
    const url = typeof window !== 'undefined'
      ? `${window.location.origin}${location.pathname}${location.search}`
      : '';

    if (title) document.title = title;
    upsertMeta('meta[name="description"]', { name: 'description', content: desc });

    // Open Graph
    upsertMeta('meta[property="og:title"]',       { property: 'og:title',       content: title });
    upsertMeta('meta[property="og:description"]', { property: 'og:description', content: desc  });
    upsertMeta('meta[property="og:type"]',        { property: 'og:type',        content: 'website' });
    upsertMeta('meta[property="og:url"]',         { property: 'og:url',         content: url   });
    if (img) upsertMeta('meta[property="og:image"]', { property: 'og:image', content: img });
    upsertMeta('meta[property="og:site_name"]',   { property: 'og:site_name',   content: 'Löwenherz Invest AG' });

    // Twitter Card
    upsertMeta('meta[name="twitter:card"]',        { name: 'twitter:card',        content: img ? 'summary_large_image' : 'summary' });
    upsertMeta('meta[name="twitter:title"]',       { name: 'twitter:title',       content: title });
    upsertMeta('meta[name="twitter:description"]', { name: 'twitter:description', content: desc  });
    if (img) upsertMeta('meta[name="twitter:image"]', { name: 'twitter:image', content: img });
  }, [social, location.pathname, location.search]);

  return null;
};
